<template>
  <v-menu
    v-model="active"
    bottom
    left
    offset-y
    max-width="25%"
    min-width="250"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" v-on="on">
        <v-avatar size="40" v-if="user.avatar">
          <img :src="user.avatar" />
        </v-avatar>
        <v-avatar size="40" color="info" v-else>
          {{ initials }}
        </v-avatar>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="pa-0">
        <v-row class="no-gutters">
          <v-col cols="auto pa-2">
            <v-avatar size="40" color="info">
              <img width="40" :src="user.avatar" v-if="user.avatar" />
              <span v-else> {{ initials }}</span>
            </v-avatar>
          </v-col>
          <v-col class="pt-1">
            <v-row class="no-gutters">
              <v-col class="subtitle-2">
                {{ user.name }}
              </v-col>
            </v-row>
            <v-row class="no-gutters">
              <v-col class="caption">
                {{ user.email }}
              </v-col>
            </v-row>
            <!-- <span class="editUser">
            <Tooltip
              content="User Settings"
              left
              icon="account-cog"
              transition="slide-x-transition"
            >
              <v-btn x-small icon :to="`/user/prefrences/${user.id}`">
                <v-icon>mdi-account-cog</v-icon>
              </v-btn>
            </Tooltip>
          </span> -->
          </v-col>
          <v-col cols="auto pa-2">
            <v-row class="my-0">
              <v-col class="pt-0 pb-1">
                <Tooltip
                  content="User Preferences"
                  left
                  icon="account-cog"
                  transition="slide-x-transition"
                >
                  <v-btn
                    x-small
                    icon
                    :to="`/preferences`"
                    @click="active = false"
                  >
                    <v-icon>mdi-account-cog</v-icon>
                  </v-btn>
                </Tooltip>
              </v-col>
            </v-row>
            <!-- <v-row class="my-0">
            <v-col v-if="role < 2" class="pt-0 pb-1">
              <Tooltip
                content="Group Settings"
                icon="cog"
                left
                transition="slide-x-transition"
              >
                <v-btn x-small icon :to="`/group/settings/${user.group}`">
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
          </v-row> -->
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="no-gutters py-1" v-if="groups.length">
          <v-col cols="auto" class="pa-2">
            <h4><v-icon small>mdi-incognito</v-icon> Account</h4>
          </v-col>
          <v-col class="px-2">
            <v-autocomplete
              :value="user.group"
              outlined
              :items="groups"
              hide-details
              dense
              @change="switchAccount"
            />
          </v-col>
        </v-row>
        <v-divider v-if="groups.length"></v-divider>
        <v-row class="no-gutters">
          <v-col cols="auto" class="pl-1">
            <Tooltip
              content="Log out"
              icon="logout"
              color="error"
              left
              transition="slide-x-transition"
            >
              <v-btn icon @click="logout">
                <v-icon color="error" small>mdi-logout</v-icon>
              </v-btn>
            </Tooltip>
          </v-col>
          <v-col class="text-right pt-2 pb-0 pr-1">
            <small class="blue--text">
              Version {{ version }}
              <img
                class="icon ml-1"
                src="../../assets/pine3_logo.svg"
                alt=""
                srcset=""
              />
            </small>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import config from "@/config";
import { v4 } from "uuid";
import Vue from "vue";
import VueTypes from "vue-types";
import { Msg, SelectItem, User } from "../../types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "UserBtn",
  data() {
    return {
      active: false,
    };
  },
  props: {
    size: VueTypes.string.def("small"),
    round: VueTypes.bool.def(false),
  },
  methods: {
    logout() {
      this.$store.dispatch("Users/logout");
      this.$router.push("/auth");
      const msg: Msg = {
        id: v4(),
        icon: "account",
        type: "info",
        content: `See you soon :)`,
        dismissible: true,
        timeout: 2000,
      };
      this.$store.dispatch("popMsg", msg);
    },
    async switchAccount(id: string) {
      this.active = false;
      this.$store.commit("setGlobalLoader", true);
      await this.$store.dispatch("Users/refreshUser", id);
      this.$router.go();
      // console.log(req, id);
    },
  },
  computed: {
    user(): User {
      return this.$store.getters["Users/getUser"];
    },
    role(): number {
      return this.$store.getters["Users/getRole"];
    },
    version(): string {
      return config.VERSION;
    },
    groups(): SelectItem[] {
      const groups = this.user.groups?.map(
        (group: { _id: string; name: string }) => {
          return {
            text: group.name,
            value: group._id,
          };
        }
      );
      return groups || [];
    },
    initials(): string {
      let init = "";
      if (this.user.name) {
        const split = this.user.name.split(" ");
        const first = split[0];
        const last = split[1];
        init = first.split("")[0] + last.split("")[0];
      }
      return init;
    },
  },
  components: { Tooltip },
});
</script>
<style scoped>
.editUser {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
  display: none;
}
.relative:hover .editUser {
  display: block;
}
.icon {
  height: 22px;
}
</style>
